<template>
    <CRow>
        <CCol col>
            <div class="col-lg-12 control-section" style="padding:10px;position:relative;">

                <div id="m2mSpinner"></div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplType' id="type" name="type" :change='onTypeChange' floatLabelType='Auto' :dataSource='products' :fields="{text: 'name', value: 'id' }" :index='typeIndex' placeholder="Product:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplCurrencyM2M' id="currencyM2M" name="currency" v-model="data.currencyId" :change="onCurrencyChangeM2M" :dataSource='currenciesM2M' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group" v-if="showPriceAreaSection">
                        <ejs-dropdownlist ref='dplPriceArea' id="priceArea" name="priceAreaName" :index='typeIndex' :actionComplete="onActionComplete" :change='onPriceAreaChange' floatLabelType='Auto' :dataSource='priceArea' :fields="{text: 'name', value: 'id' }" placeholder="Price Area:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-checkbox ref="m2mCheckDM" :change="onCheckM2mDefault" label='Default Mechanism' id="M2mCheckDefault" name="checkName" floatLabelType='Auto' cssClass="m2mCheck check-d"></ejs-checkbox>

                    </div>
                </div>
                <div class="form-row  justify-content-end ">
                    <ejs-button style="margin-right:10px" cssClass="e-primary" v-on:click.native='download'>M2M Report</ejs-button>
                </div>
                <ejs-grid ref='monthGrid' :dataSource="gridMonthData" :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='periodName' headerText='Month' width=120 :isPrimaryKey='true'></e-column>
                        <e-column headerText='TOTAL' :columns='totalColumns' textAlign="Center"></e-column>
                        <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                        <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                        <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                        <e-column field='REFERENCE' :columns='referenceColumns' textAlign="Center"></e-column>
                    </e-columns>
                </ejs-grid>
                <ejs-grid ref='quarterGrid' :dataSource="gridQuarterData" :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='periodName' headerText='Quarter' width=120 :isPrimaryKey='true'></e-column>
                        <e-column headerText='TOTAL' :columns='totalColumns' textAlign="Center"></e-column>
                        <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                        <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                        <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                        <e-column field='REFERENCE' :columns='referenceColumns' textAlign="Center"></e-column>
                    </e-columns>
                </ejs-grid>
                <ejs-grid ref='seasonGrid' :dataSource="gridSeasonData" :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='periodName' headerText='Season' width=120 :isPrimaryKey='true'></e-column>
                        <e-column headerText='TOTAL' :columns='totalColumns' textAlign="Center"></e-column>
                        <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                        <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                        <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                        <e-column field='REFERENCE' :columns='referenceColumns' textAlign="Center"></e-column>
                    </e-columns>
                </ejs-grid>
                <ejs-grid ref='calendarGrid' :dataSource="gridCalendarData" :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='periodName' headerText='Calendar Year' width=120 :isPrimaryKey='true'></e-column>

                        <e-column headerText='TOTAL' :columns='totalColumns' textAlign="Center"></e-column>
                        <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                        <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                        <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                        <e-column field='REFERENCE' :columns='referenceColumns' textAlign="Center"></e-column>
                    </e-columns>
                </ejs-grid>
                <ejs-grid ref='fiscalGrid' :dataSource="gridFiscalData" :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='periodName' headerText='Fiscal Year' width=120 :isPrimaryKey='true'></e-column>
                        <e-column headerText='TOTAL' :columns='totalColumns' textAlign="Center"></e-column>
                        <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                        <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                        <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                        <e-column field='REFERENCE' :columns='referenceColumns' textAlign="Center"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import urls from '../../common/urls';
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { ChartPlugin, ColumnSeries, StripLine, LineSeries, DataLabel, Category, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries } from "@syncfusion/ej2-vue-charts";
    import { StackingLineSeries, StackingColumnSeries, ScatterSeries, CandleSeries, Legend } from "@syncfusion/ej2-vue-charts";

    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { enableRipple } from '@syncfusion/ej2-base';
    import { TextBox } from "@syncfusion/ej2-inputs";
    import store from '../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { cibPrismic } from "@coreui/icons";
    Vue.use(ChartPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    enableRipple(true);
    export default {
        components: {
        },
        created() {
            apis.protectedApi(`utils/products?contractId=${store.state.reportContractId}&includeCombined=true`).then(it => {
                this.products = it.data;
            })
                .catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
            );

        },
        data() {
            return {
                // needed because of form being loaded from tab,in such cases this isnt available and store is loaded from import
                store: store,
                typeIndex: 0,
                //firstIndexCurrency: 3,
                draggable: true,
                contractId: parseInt(store.state.reportContractId),
                gridQuery: new Query().addParams("contractId", store.state.reportContractId),
                wrapSettings: { wrapMode: 'Header' },
                gridDataResultsMonth: null,
                gridDataResultsSeason: null,
                gridDataResultsCalendar: null,
                gridDataResultsQuarter: null,
                gridDataResultsFiscal: null,
                gridSeasonData: null,
                gridMonthData: null,
                gridCalendarData: null,
                gridQuarterData: null,
                gridFiscalData: null,
                gridSeasonDataView: false,
                gridMonthDataView: false,
                gridCalendarDataView: false,
                gridQuarterDataView: false,
                gridFiscalDataView: false,
                showPriceAreaSection: false,
                priceAreaNames: store.state.pricingAreaNames,
                products: [],
                unit: null,
                currency: null,
                currencyId: null,
                value: null,
                pageSettings: gridOptions.pageSettings,
                toolbar: [],
                filterOptions: gridOptions.filterSettings, 
                totalColumns: [{
                    field: 'totalVolumeInContractTradingUnit',
                    headerText: 'Volume',
                    textAlign: 'Center',
                    width: "120",
                    format: "n2"
                }],
                fixedColumns: [
                    {
                        field: 'fixedVolumeInContractTradingUnit',
                        headerText: 'Volume',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2"
                    },
                    {
                        field: 'fixedVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'fixedPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'fixedValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                openColumns: [
                    {
                        field: 'openVolumeInContractTradingUnit',
                        headerText: 'Volume',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2"
                    },
                    {
                        field: 'openVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'openPrice',
                        headerText: 'Market Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'openValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                m2mColumns: [
                    {
                        field: 'm2mPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'm2mValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                referenceColumns: [
                    {
                        field: 'referencePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'referenceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    },
                    {
                        field: 'varianceValue',
                        headerText: 'Variance',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                allowFiltering: true
            };
        },
        methods: {
            onActionComplete(args) { //initial load to be set on the first pricing area
                if (args.result && args.result.length > 0) {
                    this.updateTypeToShow(this.$refs.dplType.ej2Instances.text, args.result[0].id);
                }
            },
            onCheckPASystem(args) {
                let pricingAreaId = document.getElementById('priceArea') == null ? null : document.getElementById('priceArea').ej2_instances[0].value;
                let type = document.getElementById('type').value;
                if (args.checked) {
                    this.updateTypeToShow(type, pricingAreaId, args.checked);
                } else {
                    this.updateTypeToShow(type, pricingAreaId, args.checked);
                }


            },
            onPriceAreaChange: function (args) {
                let type = document.getElementById('type').value;
                if (args.isInteracted) {
                    this.updateTypeToShow(type, args.itemData == null ? null : args.itemData.id, false);
                }
            },
            onTypeChange: function (e) {
                if (e.isInteracted == true) {
                    let pricingAreaId = document.getElementById('priceArea') == null ? undefined : document.getElementById('priceArea').ej2_instances[0].value;
                    this.updateTypeToShow(e.itemData.name, pricingAreaId, false);

                }
            },
            onCheckM2mDefault(args) {
                store.state.isCheckDefaultM = args.checked;
                let currencyId = this.$refs.dplCurrencyM2M.ej2Instances.value;
                this.loadData(currencyId);

            },
            onCurrencyChangeM2M: function (args) {

                let currencyId = args.itemData.currencyId;
                this.loadData(currencyId);

            },
            textRender: function (args) {
                args.text = "";
            },
            loadData: function (currencyId) {
                showSpinner(document.getElementById('m2mSpinner'));
                showSpinner(document.getElementById('mainSpinner'));

                apis.protectedApi(`Report/GetM2mForContract?contractId=${this.contractId}&currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${this.$refs.m2mCheckDM.ej2Instances.checked}`).then(it => {
                    this.showPriceAreaSection = this.priceAreaNames == undefined ? false : true;
                    this.gridDataResultsMonth = it.data.month;
                    this.gridDataResultsSeason = it.data.season;
                    this.gridDataResultsCalendar = it.data.calendar;
                    this.gridDataResultsQuarter = it.data.quarter;
                    this.gridDataResultsFiscal = it.data.fiscal;


                    this.unit = it.data.unit;
                    this.value = it.data.value;
                    this.currency = it.data.currencySy;
                    this.$refs.m2mCheckDM.ej2Instances.checked = store.state.isCheckDefaultM;

                    if (it.data.value == 'p/therm') {

                        //this.$refs.dplCurrencyM2M.ej2Instances.value = "p";
                        this.$refs.dplCurrencyM2M.ej2Instances.text = "p - GBp";


                    } else {

                        this.$refs.dplCurrencyM2M.ej2Instances.text = it.data.currencySymbolAndName;
                    }


                    if (this.$refs.dplType.ej2Instances.dataSource.length < 2) {

                        if (this.$refs.dplType.ej2Instances.dataSource[0].name == "Gas") {

                            this.$refs.dplType.ej2Instances.text = "Gas";
                        }
                        if (this.$refs.dplType.ej2Instances.dataSource[0].name == "Baseload") {

                            this.$refs.dplType.ej2Instances.text = "Baseload";
                        }
                        if (this.$refs.dplType.ej2Instances.dataSource[0].name == "Off-Peak") {

                            this.$refs.dplType.ej2Instances.text = "Off-Peak";
                        }
                        if (this.$refs.dplType.ej2Instances.dataSource[0].name == "Peakload") {

                            this.$refs.dplType.ej2Instances.text = "Peakload";
                        }

                    } else {

                        this.$refs.dplType.ej2Instances.text = "Combined";


                    }

                    this.updateTypeToShow(this.$refs.dplType.ej2Instances.text,document.getElementById('priceArea') == null ? null : document.getElementById('priceArea').ej2_instances[0].value);
                    hideSpinner(document.getElementById('m2mSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                })

                    .catch(
                        response => {
                            hideSpinner(document.getElementById('m2mSpinner'));
                            hideSpinner(document.getElementById('mainSpinner'));
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                );
            },

            updateTypeToShow: function (type, pricingAreaId, priceSystemArea) {

                var product = this.products.filter(p => p.name == type)[0];

                if (pricingAreaId != undefined) {

                    this.gridMonthData = this.gridDataResultsMonth.areas == null ? null : this.gridDataResultsMonth.areas.filter(b => b.productName == type && b.pricingAreaId == pricingAreaId)[0].areaMonthData;
                    this.gridSeasonData = this.gridDataResultsSeason.areas != null && Array.isArray(this.gridDataResultsSeason.areas) && this.gridDataResultsSeason.areas.length > 0 ?  this.gridDataResultsSeason.areas.filter(b => b.productName == type && b.pricingAreaId == pricingAreaId)[0].areaMonthData : null;
                    this.gridQuarterData = this.gridDataResultsQuarter.areas != null && Array.isArray(this.gridDataResultsQuarter.areas) && this.gridDataResultsQuarter.areas.length > 0 ? this.gridDataResultsQuarter.areas.filter(b => b.productName == type && b.pricingAreaId == pricingAreaId)[0].areaMonthData : null;
                    this.gridFiscalData = this.gridDataResultsFiscal.areas != null && Array.isArray(this.gridDataResultsFiscal.areas) && this.gridDataResultsFiscal.areas.length > 0 ? this.gridDataResultsFiscal.areas.filter(b => b.productName == type && b.pricingAreaId == pricingAreaId)[0].areaMonthData : null;
                    this.gridCalendarData = this.gridDataResultsCalendar.areas != null && Array.isArray(this.gridDataResultsCalendar.areas) && this.gridDataResultsCalendar.areas.length > 0 ? this.gridDataResultsCalendar.areas.filter(b => b.productName == type && b.pricingAreaId == pricingAreaId)[0].areaMonthData : null;

                    this.$refs.monthGrid.refresh();
                    this.$refs.seasonGrid.refresh();
                    this.$refs.calendarGrid.refresh();
                    this.$refs.fiscalGrid.refresh();
                    this.$refs.quarterGrid.refresh();
                }
                else {

                    if (product && product.productName == 'Combined') {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.combined;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.combined;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.combined;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.combined;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.combined;
                    } else if (product && product.productName == 'Baseload') {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.base;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.base;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.base;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.base;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.base;
                    } else if (product && product.productName == 'Peakload') {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.peak;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.peak;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.peak;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.peak;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.peak;
                    } else if (product && product.productName == 'Gas') {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.gas;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.gas;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.gas;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.gas;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.gas;
                    } else if (product && product.productName == 'Combined') {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.combined;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.combined;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.combined;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.combined;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.combined;
                    } else {
                        this.gridMonthData = this.gridDataResultsMonth == null ? null : this.gridDataResultsMonth.offPeak;
                        this.gridSeasonData = this.gridDataResultsSeason == null ? null : this.gridDataResultsSeason.offPeak;
                        this.gridCalendarData = this.gridDataResultsCalendar == null ? null : this.gridDataResultsCalendar.offPeak;
                        this.gridQuarterData = this.gridDataResultsQuarter == null ? null : this.gridDataResultsQuarter.offPeak;
                        this.gridFiscalData = this.gridDataResultsFiscal == null ? null : this.gridDataResultsFiscal.offPeak;
                    }
                    this.$refs.monthGrid.refresh();
                    this.$refs.seasonGrid.refresh();
                    this.$refs.calendarGrid.refresh();
                    this.$refs.fiscalGrid.refresh();
                    this.$refs.quarterGrid.refresh();

                }
                
            },
            customiseCell: function (args) {

                if (args.data['periodName'].includes('TOTAL')) {
                    args.cell.classList.add('greyBox');
                }


                var yearY = args.data['periodName'].substring(0, 1);

                if (yearY == 'Y') {
                    args.cell.classList.add('greyBox');
                }
                if (args.column.field === 'varianceValue') {
                    if (args.data['varianceValue'] > 0) {
                        args.cell.classList.remove('greyBox');
                        args.cell.classList.add('greenBox');
                        args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                    } else {
                        args.cell.classList.remove('greyBox');
                        args.cell.classList.add('redBox');
                        args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                    }
                }
                else if (args.column.field === 'totalVolumeInContractTradingUnit' || args.column.field === 'openVolumeInContractTradingUnit' || args.column.field === 'fixedVolumeInContractTradingUnit') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.unit;
                } else if (args.column.field === 'fixedVolumePercentage' || args.column.field === 'openVolumePercentage') {
                    args.cell.textContent = args.cell.textContent + ' ' + "%";
                } else if (args.column.field === 'fixedPrice' || args.column.field === 'openPrice' || args.column.field === 'm2mPrice' || args.column.field === 'referencePrice' || args.column.field === 'variancePrice') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.value;
                } else if (args.column.field === 'referenceValue' || args.column.field === 'openValue' || args.column.field === 'm2mValue' || args.column.field === 'fixedValue' || args.column.field === 'varianceValue') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                }
            },
            download: function (args) {
                showSpinner(document.getElementById('m2mSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                this.currencyId = this.$refs.dplCurrencyM2M.ej2Instances.value;
                let pricingAreaId = document.getElementById('priceArea')?.ej2_instances[0]?.value;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateM2mReportPage/${this.contractId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${this.$refs.m2mCheckDM.ej2Instances.checked}&pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&pricingAreaSystem=${false}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('m2mSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('m2mSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },

        }, mounted: function () {
            createSpinner({
                target: document.getElementById('m2mSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            this.loadData();
        }, computed: {
             currenciesM2M() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?contractId=" + store.state.reportContractId);
            },
            priceArea() {
                return SyncHelper.getDataManager("utils/pricingContractAreas?contractId=" + store.state.reportContractId); 
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn],
            chart: [ColumnSeries, StripLine, LineSeries, Category, DataLabel, DateTime, Tooltip, ChartAnnotation, ScatterSeries, StackingColumnSeries, CandleSeries, Zoom, MultiColoredLineSeries, StackingLineSeries, Legend]
        }
    };

</script>
<style>
    #container {
        height: 350px;
    }

    .greenBox {
        background-color: #62bf82 !important;
        color: green;
    }

    .greyBox {
        background-color: lightgrey !important;
        font-weight: 500;
    }

    .redBox {
        background-color: #b83726 !important;
        color: green;
    }

    .m2mCheck {
        margin: 32px 382px 0px 0px;
    }

    #m2mSpinner {
        display: none;
    }


</style>
